module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/estimate_2-6b653586312d93ee7cfeaa7db9bb47b6.jpg";